import { createAction, props } from "@ngrx/store";
import { RecursivePartial } from "../recursive-partial";
import { CompanyAppliedFilter, CompanySearchFilters, ContactAppliedFilter, ContactSearchFilters, SearchOptions, SearchState } from "./search.state";

export const ExtendStateAction = createAction(
    "[Contact Search Action] Extend State",
    props<{ newState: Partial<SearchState> }>(),
);

export const MergeStateAction = createAction(
    "[Contact Search Action] Merge State",
    props<{ newState: RecursivePartial<SearchState> }>(),
);

export const InitializeAction = createAction(
    "[Contact Search Action] Initialize Action",
);

export const ActiveTabChange = createAction(
    "[Contact Search Action] ActiveTabChange Action",
    props<{ activeTab: "Company" | "Contact" }>(),
);

export const SearchAction = createAction(
    "[Contact Search Action] Search Action",
    props<{ searchTerm: string }>(),
);

export const ClearSearchAction = createAction(
    "[Contact Search Action] Clear Search Action",
    props<{ searchTerm: string }>(),
);

export const CompanySearchOptionsChangedAction = createAction(
    "[Contact Search Action] Company SearchOptionsChangedAction",
    props<{ searchOptions: SearchOptions }>(),
);

export const CompanyFilterChangedAction = createAction(
    "[Contact Search Action] Company CompanyFilterChangedAction",
    props<{ appliedFilter: CompanyAppliedFilter }>(),
);

export const CompanyFilterToggledAction = createAction(
    "[Contact Search Action] Company CompanyFilterToggledAction",
    props<{ filterName: keyof CompanySearchFilters }>(),
);

export const CompanySortingChangedAction = createAction(
    "[Contact Search Action] Company CompanySortingChangedAction",
    props<{ sortField: string }>(),
);

export const CompanyPagerChangedAction = createAction(
    "[Contact Search Action] Company CompanyPagerChangedAction",
    props<{ pageNumber: number, pageSize: number }>(),
);

export const ContactSearchOptionsChangedAction = createAction(
    "[Contact Search Action] ContactSearchOptionsChangedAction",
    props<{ searchOptions: SearchOptions }>(),
);

export const contactSearchAndFilterChangedAction = createAction(
  "[Contact Search Action] contactSearchAndFilterChangedAction",
  props<{ searchOptions: SearchOptions, appliedFilter:ContactAppliedFilter[], location }>(),
);

export const companySearchAndFilterChangedAction = createAction(
    "[Contact Search Action] contactSearchAndFilterChangedAction",
    props<{ searchOptions: SearchOptions, appliedFilter:CompanyAppliedFilter[] }>(),
  );

export const ContactFilterChangedAction = createAction(
    "[Contact Search Action] Contact CompanyFilterChangedAction",
    props<{ appliedFilter: ContactAppliedFilter }>(),
);

export const ContactFilterToggledAction = createAction(
    "[Contact Search Action] Contact CompanyFilterToggledAction",
    props<{ filterName: keyof ContactSearchFilters }>(),
);

export const ContactSortingChangedAction = createAction(
    "[Contact Search Action] Contact CompanySortingChangedAction",
    props<{ sortField: string }>(),
);

export const ContactPagerChangedAction = createAction(
    "[Contact Search Action] Contact CompanyPagerChangedAction",
    props<{ pageNumber: number, pageSize: number }>(),
);


export const ContactAdvanceFilterChangedAction = createAction(
  "[Contact Search Action] Contact ContactAdvanceFilterChangedAction",
  props<{ appliedFilter: ContactAppliedFilter }>(),
);

export const ClearAllAction = createAction(
    "[Clear Search Action] Search Action"
);

export const companyInitializeAction = createAction(
    "[Company Search Action] Initialize Action",
);
export const contactInitializeAction = createAction(
    "[Contact Search Action] Initialize Action",
);
